const renewalDetailsFormatter = (data, renewalData) => {

  const dataSet = data;
  dataSet["id"] = renewalData?.aadhar_id
  return dataSet;
};

  export default renewalDetailsFormatter;
  